import { ADD_TO_CONTEXT_MENU,

  TOGGLE_CONTEXT_MENU,
  } from '../../actions/musica/music-actions';

const initialState = {
  currentContent: {},
  showModal: false
};

const addToContextMenu = (state, action) => {
  const currentContent = action.currentContent;
  return {
    ...state,
    currentContent
  };
};

const toggleContextMenu = (state, action) => {
  return {
    ...state,
    showModal: !state.showModal,
  }
};

function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case ADD_TO_CONTEXT_MENU:
      return addToContextMenu(state, action);
    case TOGGLE_CONTEXT_MENU:
      return toggleContextMenu(state, action);
    default:
      return state;
  }
}

export default reducer;



// WEBPACK FOOTER //
// ./src/reducers/musica/contextmenu.js